import { observer } from "mobx-react";
import React from "react";
import { IGeneralModule } from "../Utils/Interface";

type Props = {
	addOn: IGeneralModule;
	onChange: (addOn: IGeneralModule) => void;
	isSelected: (addOn: IGeneralModule) => boolean;
};


@observer
class GeneralModuleAddOns extends React.Component<Props> {

	render() {
		return (
			<label className={`multi-select-label addon`}>
				<input
					type="checkbox"
					className="multi-select-check-input"
					onChange={(e) => this.props.onChange(this.props.addOn)}
					value={this.props.addOn.title}
					checked={this.props.isSelected(this.props.addOn)}
				/>
				<span>{this.props.addOn.title}</span>
			</label>
		);
	}
}

export default GeneralModuleAddOns;
